// components/attendance/components/PPEStatusBadge.js
import React from 'react';
import Icon from './appIcon';

const PPEStatusBadge = ({ status, missingItems }) => {
  // If no status, show unknown
  if (!status) {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
        Unknown
      </span>
    );
  }

  // Handle compliant status
  if (status === 'compliant') {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 flex items-center space-x-1">
        <Icon name="CheckCircle" size={12} />
        <span>Compliant</span>
      </span>
    );
  }

  // Handle non-compliant status
  if (status === 'non_compliant') {
    return (
      <div className="flex flex-col">
        <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 flex items-center space-x-1 mb-1">
          <Icon name="AlertCircle" size={12} />
          <span>Non-Compliant</span>
        </span>
        {missingItems && missingItems.length > 0 && (
          <div className="text-xs text-red-600 mt-1">
            Missing: {missingItems.join(', ')}
          </div>
        )}
      </div>
    );
  }

  // Default to unknown
  return (
    <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
      Unknown
    </span>
  );
};

export default PPEStatusBadge;